import ModalDeleteFilled from '../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'


interface ModalDeletePaymentMethodProps extends ModalEditComponentProps { }

const ModalDeletePaymentMethod: React.FC<ModalDeletePaymentMethodProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/config/payment/paymentMethod/updatePaymentMethod',
        data: {
            id: allRowData?.id,
            active: !allRowData?.active
        }
    })
    let translations = {
        title: t('sureUnablePaymentMethod', '¿Seguro quieres desactivar este método de pago?'),
        subtitle: t('onceDeletedCouldBeRecovered', 'Una vez desactivado se podrá reactivar de nuevo'),
        buttonAccept: t('unable', 'Desactivar')
    }
    if (!allRowData?.active) {
        translations = {
            title: t('sureEnablePaymentMethod', '¿Seguro quieres activar este método de pago?'),
            subtitle: t('onceEnabledCouldBeDeleted', 'Una vez activado se podrá desactivar de nuevo'),
            buttonAccept: t('enable', 'Activar')
        }
    }
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={translations} />
    )
}

export default ModalDeletePaymentMethod